import { HttpService, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { AdvanceSummary } from '@skylab-shared/dataModel';
import { fillPlaceholders } from '@skylab-shared/utils';

type AdvanceSummaryData = Omit<AdvanceSummary, 'vatTable'> & {
    vatTable: {
        currencyId: number;
        items: {
            gross: number;
            net: number;
            vat: number;
            vatRate: number;
            vatRateId: number;
        }[];
    };
};

export class AdvanceSummaryQuery extends Query<AdvanceSummary> {
    public constructor(public readonly documentId: number) {
        super();
    }
}

export class AdvanceSummaryQueryHandlerBase implements QueryHandler<AdvanceSummaryQuery> {
    private static Url = TaggedUrl.join('sales/:id/advanceSummary', [Tags.Api]);

    public constructor(
        private readonly http: HttpService
    ) { }

    public async handleAsync(params: AdvanceSummaryQuery): Promise<AdvanceSummary> {
        const url = fillPlaceholders(AdvanceSummaryQueryHandlerBase.Url, { id: params.documentId });
        const { data } = await this.http.get<AdvanceSummaryData>(url);

        return {
            advance: data.advance,
            itemsHistory: data.itemsHistory,
            vatTable: {
                currencyId: data.vatTable?.currencyId,
                items: data.vatTable?.items.map(x => ({
                    grossValue: x.gross,
                    netValue: x.net,
                    vatValue: x.vat,
                    vatRate: x.vatRate,
                    vatRateId: x.vatRateId
                }))
            },
            currencyVatTable: null as any
        };
    }
}
